// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const StaffFullName = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="fullName" label="Full Name">
      <Input placeholder="fullName" disabled={disabled} />
    </Form.Item>
  );
};

export default StaffFullName;
